/* global EPIC_GEOLOCATION_DATA */
/* eslint no-console: "off" */
import 'promise-polyfill/src/polyfill';
import 'unfetch/polyfill';
import docCookies from 'cookies.js';

function ready(fn) {
	if (document.readyState != 'loading') {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

window.docCookies = docCookies;
const Geolocation = {
	continue: true,
	break: false,
	key: null,
	country: null,
	fallback_country_name: 'United States',
	fallback_country_code: 'US',
	original_callbacks: null,
	init() {
		// Bail if data isn't available
		if ( !window.EPIC_GEOLOCATION_DATA ) {
			return;
		}
		this.key = EPIC_GEOLOCATION_DATA.key;
		this.getCountry();
	},
	getCountry() {
		const url = `https://api.ipstack.com/check?access_key=${this.key}&fields=country_name,country_code,ip`;
		fetch(url)
			.then(function(response) {
				console.log('check response');
				if ( !response.ok ) {
					console.log('response is not ok');
					throw Error(response.statusText);
				}
				return response;
			})
			.then( r => { console.log('get json'); return r.json(); } )
			.then( data => {
				// ipstack reports errors (bad key, quota) in a 200 response body
				if ( !data || !data.country_code ) {
					throw Error('no country in lookup response');
				}
				return { country: data.country_name, country_code: data.country_code };
			} )
			// Only lookup failures fall back - errors applying rules must not
			// rerun countryCallback with the fallback country
			.catch( error => {
				console.error('lookup error: ', error);
				return { country: this.fallback_country_name, country_code: this.fallback_country_code };
			} )
			.then( result => { console.log('country callback'); return this.countryCallback(result.country, result.country_code); } )
			.catch( error => console.error('geolocation error: ', error) )
		;
	},
	countryCallback(country, country_code) {
		console.log('countryCallback - country: ', country, ' && country_code: ', country_code);
		EPIC_GEOLOCATION_DATA.country_code = country_code;
		let callbacks = window.EPIC_GEOLOCATION_CALLBACKS || [];
		if ( this.original_callbacks === null ) {
			this.original_callbacks = callbacks;
		}
		window.EPIC_GEOLOCATION_CALLBACKS = {
			push(cb) {
				cb(country_code);
			}
		};

		if ( callbacks.forEach ) {
			// callbacks responds to forEach
			callbacks.forEach( cb => cb(country_code) );
		} else {
			// Duplicate call - use original callbacks for loop
			this.original_callbacks.forEach( cb => cb(country_code) );
		}

		if ( typeof window.epic_pricing_box === 'object' ) {
			window.epic_pricing_box.pickRegion(country_code);
		}

		this.country = country;
		if ( EPIC_GEOLOCATION_DATA.redirect_rules.length > 0 ) {
			if ( docCookies.getItem('epic_geo_redir_skip') === 'true' ) {
				console.log('skip redirect');
			} else {
				this.conditionalRedirect();
			}
		}
		if ( EPIC_GEOLOCATION_DATA.content_rule_sets.length > 0 ) {
			this.conditionalContent();

			ready( () => this.sidrSetupCheck(() => this.conditionalContent()) );
		}
		return true;
	},
	sidrSetupCheck(callback) {
		let $$ = document.getElementById('sidr-main');
		if ( $$ ) {
			callback();
		} else {
			const sidr_interval = setInterval( () => {
				$$ = document.getElementById('sidr-main');
				if ( !$$ ) { return; }

				clearInterval(sidr_interval);
				callback();
			}, 100);
			setTimeout( () => clearInterval(sidr_interval), 5000 );
		}
	},
	conditionalRedirect() {
		EPIC_GEOLOCATION_DATA.redirect_rules.every(this.testRedirectRule.bind(this));
	},
	testRedirectRule(rule) {
		if ( this.ruleMatches(rule) ) {
			if ( rule.countries.indexOf('Iceland') >= 0 ) {
				const iceland_cookie = 'epic_geo_redir_skip_iceland';

				if ( docCookies.getItem(iceland_cookie) === 'true' ) {
					// Cookie set, don't redirect
					return this.continue;
				}

				// set cookie and redirect
				const day_in_seconds = 24*60*60;
				docCookies.setItem(iceland_cookie, 'true', day_in_seconds, '/');
			}

			document.location = rule.destination;
			return this.break;
		}

		return this.continue;
	},
	ruleMatches(rule) {
		if ( rule.any ) {
			return true;
		}

		const idx = rule.countries.indexOf(this.country);
		if ( idx >= 0 ) {
			return true;
		}

		return false;
	},
	conditionalContent() {
		EPIC_GEOLOCATION_DATA.content_rule_sets.forEach(
			rule_set => rule_set.rules.every(this.testContentRule.bind(this))
		);
	},
	testContentRule(rule) {
		if ( this.ruleMatches(rule) ) {
			this.ready( () => this.processContentRuleActions(rule.actions) );
			return this.break;
		}

		return this.continue;
	},
	ready(fn) {
		if ( document.readyState != 'loading' ) {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	},
	processContentRuleActions(actions) {
		actions.forEach( action => {
			// Skip actions with a blank selector - querySelectorAll throws on ''
			if ( !action.selector || !action.selector.trim() ) {
				return;
			}
			// A malformed selector skips only its own action
			try {
				const els = document.querySelectorAll(action.selector);
				const display_val = action.behavior === 'hide' ? 'none' : '';
				els.forEach( _ => _.style.display = display_val );
			} catch ( error ) {
				console.error('geolocation selector error: ', action.selector, error);
			}
		} );
	}
};

Geolocation.init();

